import { createInMemoryAtom } from '@exodus/atoms'

const createShownForcedAnnoucementsAtom = ({ storage }) =>
  createInMemoryAtom({
    defaultValue: Object.create(null),
  })

export default createShownForcedAnnoucementsAtom
